import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { LicenseService } from 'common/util/module'
import { MediaFile, MediaFileBundle, MediaRoot } from 'elements-sdk'
import { CustomFieldsService } from 'media.customFields'
import { MediaAssetRatingsService } from 'media/services/mediaAssetRatings.service'

interface Label {
  name: string
  value: any
  icon: string
  color: string
  type: string
}

@Component({
  selector: 'media-item-labels',
  templateUrl: './mediaItemLabels.component.pug',
  styleUrls: ['./mediaItemLabels.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaItemLabelsComponent {
  @Input() bundle?: MediaFileBundle
  @Input() directory?: MediaFile
  @Input() location?: MediaFile
  @Input() showRating = false
  @Input() showOffline = false
  @Input() root?: MediaRoot

  customLabels: Label[] = []
  private effectiveCustomFields: Record<string, any> = {}

  constructor (
    public license: LicenseService,
    private customFields: CustomFieldsService,
    private mediaAssetRatings: MediaAssetRatingsService,
  ) {
  }

  ngOnInit () {
    if (this.root) {
      this.buildCustomLabels()
    }
  }

  ngOnChanges () {
    this.effectiveCustomFields = this.customFields.combine(
      this.location?.effectiveCustomFields,
      this.directory?.customFields,
      this.bundle?.asset?.customFields,
      this.bundle?.mainfile.customFields,
    )
  }

  buildCustomLabels () {
    this.customLabels = []
    for (const field of this.root?.customFields ?? []) {
      this.customLabels = this.customLabels.concat(
        field.labels?.map(label => ({
          name: field.name,
          type: field.type,
          ...label,
        }) as Label) ?? [],
      )
    }
  }

  shouldShowCustomLabel (label: Label) {
    const value = this.effectiveCustomFields[label.name]

    if (label.type === 'select' && Array.isArray(value)) { // multiselect
      return value.includes(label.value)
    }

    if (label.type === 'checkbox') { // checkbox
      return label.value === (value ? 'checked' : 'unchecked')
    }

    return this.effectiveCustomFields[label.name] === label.value
  }

  isBundlePresent () {
    return (!this.bundle?.asset || this.bundle.asset.hasFiles) && this.bundle?.mainfile.present
  }
}
